// @owners { team: patients }
import { type CartItem } from '@alto/orders_api/types/v1/cart_item';

/**
 * Prescription IDs from cart items for API params (e.g. order_bundling_options).
 * Uses resource_id directly — does not require Redux prescriptionsHash.
 */
export const getCartPrescriptionResourceIds = (cartItems: CartItem[]): number[] => {
  const ids = cartItems
    .filter((cartItem) => cartItem.resource_type === 'Prescription')
    .map((cartItem) => cartItem.resource_id);

  return [...ids].sort((a, b) => a - b);
};
